<template>
    <section style="margin-top: 30px; margin-bottom: 100px;">
        <div class="container mt-4">
            <div class="row justify-content-center">
                <div class="col-md-6 col-sm-12 mb-4">
                    <div class="p-4 rounded text-center border">
                        <div>
                            <img src="../assets/img/signup.png" alt="Signup Image">
                        </div>

                        <!-- Etape 1 : e-mail + mot de passe -->
                        <form v-if="step === 'password'" @submit.prevent="submitForm" style="margin-top: 20px;">
                            <div class="form-group mb-3">
                                <input type="email" class="form-control" :placeholder="translate('email')" required v-model="email" :class="{ 'fill-out': email, 'not-fill-out': !email }">
                            </div>
                            <div class="form-group mb-3">
                                <input type="password" class="form-control" :placeholder="translate('password')" required v-model="password" :class="{ 'fill-out': password, 'not-fill-out': !password }">
                            </div>
                            <div class="text-center mt-3">
                                <button type="submit" class="btn btn-login2 me-2" :disabled="loading">{{ loading ? '...' : translate('login') }}</button>
                            </div>
                        </form>

                        <!-- Etape 2 : code de double authentification -->
                        <form v-else @submit.prevent="submitCode" style="margin-top: 20px;">
                            <p class="text-muted small mb-3">
                                Entrez le code a 6 chiffres de votre application d'authentification.
                            </p>
                            <div class="form-group mb-3">
                                <input type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="9"
                                    class="form-control text-center" style="letter-spacing: 4px; font-size: 1.3rem;"
                                    placeholder="000000" required v-model="code" ref="codeInput">
                            </div>
                            <div class="form-check d-flex justify-content-center mb-3">
                                <input class="form-check-input me-2" type="checkbox" id="trustDevice" v-model="trustDevice">
                                <label class="form-check-label small" for="trustDevice">Faire confiance a ce navigateur pendant 30 jours</label>
                            </div>
                            <div class="text-center mt-3">
                                <button type="submit" class="btn btn-login2 me-2" :disabled="loading">{{ loading ? 'Verification...' : 'Valider' }}</button>
                                <br>
                                <a href="#" class="small text-muted d-inline-block mt-3" @click.prevent="resetToPassword">Recommencer</a>
                                <p class="small text-muted mt-2 mb-0">Telephone perdu ? Entrez un code de secours a la place.</p>
                            </div>
                        </form>

                        <div class="notification is-danger" v-if="errors.length" style="margin-top: 20px;">
                            <p v-for="error in errors" :key="error">{{ error }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';

export default {
    name: 'LogIn',
    mixins: [en, fr, nl],
    data() {
        return {
            step: 'password',
            email: '',
            password: '',
            code: '',
            trustDevice: false,
            twofaTicket: '',
            loading: false,
            errors: []
        }
    },
    mounted() {
        document.title = 'Log In | Eurekali'
    },
    computed: {
        lang() {
            return this.$store.state.lang || 'en'
        },
    },
    methods: {
        translate(prop) {
            const currentLang = this.lang || 'en';
            const dict = this[currentLang] || this.en || {};
            return dict[prop] || '';
        },
        deviceKey() {
            return 'b2c_device_token_' + (this.email || '').toLowerCase()
        },
        finishLogin(token) {
            if (!token) {
                // Réponse sans jeton (ex. « 2FA requise » non comprise par un vieux front) :
                // ne JAMAIS stocker « undefined » — c'est ce qui donnait « connecté mais rien ne s'affiche ».
                this.errors.push("Connexion incomplète : le serveur n'a pas renvoyé de jeton. Rechargez la page (Cmd/Ctrl+Shift+R) et réessayez.")
                return
            }
            this.$store.commit('setApiError', null)
            this.$store.commit('setToken', token)
            axios.defaults.headers.common["Authorization"] = "Token " + token
            sessionStorage.setItem("token", token)
            const toPath = this.$route.query.to || '/shipments-progress'
            this.$router.push(toPath)
        },
        async submitForm() {
            this.errors = []
            axios.defaults.headers.common["Authorization"] = ""
            sessionStorage.removeItem("token")
            this.loading = true
            let deviceToken = ''
            try { deviceToken = localStorage.getItem(this.deviceKey()) || '' } catch (e) { deviceToken = '' }
            try {
                const { data } = await axios.post("/api/v1/admin/login/", {
                    email: this.email,
                    password: this.password,
                    device_token: deviceToken
                })
                if (data.twofa_required) {
                    this.twofaTicket = data.twofa_ticket
                    this.step = 'code'
                    this.$nextTick(() => { if (this.$refs.codeInput) this.$refs.codeInput.focus() })
                } else {
                    this.finishLogin(data.auth_token)
                }
            } catch (error) {
                this.errors.push(this.translate('login_error') || 'E-mail ou mot de passe incorrect')
            } finally {
                this.loading = false
            }
        },
        async submitCode() {
            this.errors = []
            this.loading = true
            try {
                const { data } = await axios.post("/api/v1/admin/2fa/verify/", {
                    twofa_ticket: this.twofaTicket,
                    code: this.code,
                    trust_device: this.trustDevice
                })
                if (this.trustDevice && data.device_token) {
                    try { localStorage.setItem(this.deviceKey(), data.device_token) } catch (e) { /* ignore */ }
                }
                this.finishLogin(data.auth_token)
            } catch (error) {
                const msg = error.response && error.response.data && error.response.data.error
                this.errors.push(msg || 'Code incorrect.')
            } finally {
                this.loading = false
            }
        },
        resetToPassword() {
            this.step = 'password'
            this.code = ''
            this.errors = []
        }
    }
}
</script>

<style>
.btn-login2 {
    background-color: #E5097F;
    color: white;
    margin-left: 15px;
    border-radius: 20px;
    font-weight: bold;
    padding-left: 25px;
    padding-right: 25px;
}
.btn-login2:hover {
    background-color: #9b0656;
    color: white;
}
</style>
